export const formModal = {
  methods: {
    /**
     * Управляет глобальным спинером формы
     */
    loading(val) {
      this.loadingForm = val;
      this.$emit("loading", val);
    },

    /**
     * Закрытия модального окна
     */
    async close(askBeforeClose = false) {
      if (typeof askBeforeClose === "boolean" && askBeforeClose) {
        const res = await this.$dialog.confirm({
          text: "Вы уверены, что хотите закрыть это окно?",
          title: "Внимание",
          actions: {
            false: "Нет",
            true: {
              text: "Да",
              color: "primary",
            },
          },
        });
        if (!res) {
          return;
        }
      }
      this.loadingForm = false;
      this.resetForm();
      this.$emit("close");
      this.$emit("submit");
    },

    /**
     * Сброс формы
     */
    resetForm() {
      if (this.$v) {
        this.$v.$reset();
        this.form = {};
      }
    },
  },
};
